import { render } from "./InputRadioGroup.vue?vue&type=template&id=48a052de"
import script from "./InputRadioGroup.vue?vue&type=script&lang=js"
export * from "./InputRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__